import { isValidUserId, toUserId } from '@streamr/utils';
/**
 * Collapses alternate serializations (e.g. bare hex vs 0x-prefixed) to the
 * canonical UserID string used on the wire, so Map keys and prefix lookups match.
 */
export function canonicalUserId(id) {
    const s = id.trim();
    if (isValidUserId(s)) {
        return toUserId(s);
    }
    if (/^[a-fA-F0-9]+$/.test(s)) {
        return toUserId(`0x${s.toLowerCase()}`);
    }
    throw new Error(`canonicalUserId: unrecognised user id form: ${id}`);
}
